import { useState, useEffect } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useDealer = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    firstname: "",
    lastname: "",
    personal: "",
    email: "",
    mobile: ""
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/dealer/list", filter)
      setItems(response.data.dealers);
      setTotal(response.data.total);
      return response.data.dealers
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/dealer/all", requestData)
      setItems(response.data.dealers);
      setTotal(response.data.total);
      return response.data.dealers
    } catch (error) {

      console.error("error:" + error);
    }
  }
  const add = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/dealer/create`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };
  

  const search = async (dealer, count) => {
    try {
      const requestData = {
        dealer: dealer,
        count: count,
      };

      const response = await automobyApi.post("/dealer/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/dealer/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          dealer_id: id
        };
        const response = await automobyApi.post(`/dealer/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (dealer) => {
    setItems(items.map(item =>
      item.id === dealer.id ? dealer : item
    ));
  }
 
  const dealerService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove,  
  };

  return { dealerService };
}